import { state } from '../store'

export default {
  gcGroup_inviteList: {
    get: () => state.gsGroup_inviteList,
    set: (value = []) => state.gsGroup_inviteList = value
  },
}